import type { TFunction } from 'i18next';
import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Targetable } from '@feathr/blackbox';
import { Button, type IColumn, TableColumnHeader } from '@feathr/components';

import GeoFiltersOptions from '../GeoFiltersOptions';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

function TargetablesColumns(t: TFunction): Array<IColumn<Targetable>> {
  return [
    {
      Header: TableColumnHeader({
        title: t('Geofilter set'),
        sortType: 'alpha',
      }),
      id: 'name',
      headerClassName: tableStyles.cellLeft,
      sortable: true,
      Cell({ original }): JSX.Element {
        return (
          <Observer>
            {(): JSX.Element => <Button type={'link'}>{original.get('name')}</Button>}
          </Observer>
        );
      },
    },
    {
      Header: TableColumnHeader({
        title: t('Options'),
      }),
      id: 'options',
      width: 100,
      sortable: false,
      Cell(): JSX.Element {
        return (
          <div className={tableStyles.cellCenter}>
            <Observer>{(): JSX.Element => <GeoFiltersOptions />}</Observer>
          </div>
        );
      },
    },
  ];
}

export default TargetablesColumns;
